import { action, makeObservable, observable } from 'mobx';
import { ReactNode } from 'react';

import { injectable } from '@servicetitan/react-ioc';

import { MessageType } from '../models/message-type.model';
import { scrollToBottom } from '../utils/scroll-to-bottom';

export interface IMessage {
    id?: string;
    scrollToId?: boolean;
    type: MessageType;
    isMine: boolean;
    data?: unknown;
    text?: string;
    title?: string;
    removable?: boolean;
    date?: Date;
    showAvatar?: boolean;
    showBubble?: boolean;
    onClick?: (data?: any) => void;
    getView?: () => ReactNode;
}

export interface SelectedEquipmentInfo {
    name: string | null;
    manufacturer: string;
    model?: string;
}

@injectable()
export class ChatStore {
    @observable
    messages: IMessage[] = [];
    private messagesToRender: IMessage[] = [];

    private isLoading = false;
    private timeout?: ReturnType<typeof setTimeout>;

    constructor() {
        makeObservable(this);
    }

    @action
    addMessage(message: IMessage) {
        this.messages.push(message);
        scrollToBottom(message);
    }

    enqueueMessages(messages: IMessage[]) {
        this.messagesToRender = this.messagesToRender.concat(messages);
        if (!this.isLoading) {
            this.loadEnqueuedMessages();
        }
    }

    @action
    filterOutRemovableMessages = () => {
        this.messagesToRender = this.messagesToRender.filter(message => {
            return !message.removable;
        });
        this.messages = this.messages.filter(message => {
            return !message.removable;
        });
    };

    @action
    resetMessaging() {
        this.messages = [];
        this.messagesToRender = [];
        clearTimeout(this.timeout);
        this.timeout = undefined;
        this.isLoading = false;
    }

    private loadEnqueuedMessages = () => {
        if (this.messagesToRender.length === 0) {
            this.isLoading = false;
            return;
        }
        this.isLoading = true;
        const message = this.messagesToRender.shift()!;

        this.addMessage(message);
        this.loadEnqueuedMessages();
    };
}
